import React, {useContext, useEffect} from "react";
import {ClientContext} from "./ClientView";
import {TabbedPageHeader} from "../../../../../components/TabbedPageHeader";
import {com, space,} from "../../../../../provider_api";
import {KensuTable} from "../../../../../components/table/KensuTable";
import {priceToString} from "../../../../../util/PriceUtil";
import {shortDateTimeFormat2} from "../../../../../util/DateTimeUtils";
import {useNavigateWithParams} from "../../../../../util/NavUtils";
import {paymentStatusWidget} from "../../Billing/Payments";
import IApiPaymentProto = space.kenko.proto.IApiPaymentProto;
import GetStripePaymentsRequest = com.onkensu.platform.billing.GetStripePaymentsRequest;
import {useGetStripePayments} from "../../../../../util/RpcHooks/GetStripePayments";
import {fullName} from "../../../../../util/BookingUtil";
import {LoadingDots} from "../../../../../util/UI/LoadingDots";

export const ClientTransactions = () => {

  const {client} = useContext(ClientContext);
  const navigate = useNavigateWithParams();
  const paymentsRpc = useGetStripePayments();
  
  // Load attendees if editing. New events obviously have no signups.
  useEffect(() => {

    if (!client) {
      return;
    }
    
    paymentsRpc.send(new GetStripePaymentsRequest({
      userId: client?.user?.userId,
      limit: 20
    }));

  }, [client])

  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={`Client: ${fullName(client?.user)}`}
                      buttons={[{text: 'Back to Clients', link: '../..', isSecondary: true}]}
                      tabs={[
                            {label: 'Profile', link: '../'},
                            {label: 'Bookings', link: '../bookings'},
                            {label: 'Payments', link: './', isSelected: true},
                          ]}
    />


    <div className={'ProviderToolAreaContent'}>

      <h2>Payments</h2>
      <KensuTable<IApiPaymentProto>
          onRowSelected={row => navigate('/home/billing/payments/' + row.paymentId)}
          data={paymentsRpc.payments}
          defaultSort={{ascending: false, columnIndex: 0}} // sort on date
          columns={[
            {label: 'Date', render: row => shortDateTimeFormat2(row.createdTimestampMs), sortOrder: row => row.createdTimestampMs},
            {label: 'Price', render: row => priceToString(row.price, true)},
            {label: 'Purchase', render: row => row.purchasedThingName},
            {label: 'Payment Status', render: paymentStatusWidget},
          ]}/>

      {paymentsRpc.rpcState.state == 'pending' && !paymentsRpc.payments?.length && <div>Loading transactions<LoadingDots/></div>}
      {paymentsRpc.rpcState.state == 'success' && !paymentsRpc.payments?.length && <div>No transactions found.</div>}
      {paymentsRpc.rpcState.state == 'error' && <div className={'ErrorText'}>{paymentsRpc.rpcState.message}</div>}

    </div>
  </div>
}
